module.exports = __webpack_public_path__ + "img/pencil.d782bceb.svg";